// extracted by mini-css-extract-plugin
export default {"content":"DraggableList_content__rVDcp"};